import type { JSX } from 'react';
import React from 'react';
import type { RouteProps } from 'react-router-dom';
import { Route } from 'react-router-dom';

import RedirectTo403 from './RedirectTo403';

interface IPrivateRouteProps extends RouteProps {
  children: JSX.Element;
  condition: boolean | undefined;
  fallback?: JSX.Element;
}

function RouteWithPermissions({
  children,
  condition,
  fallback,
  ...rest
}: Readonly<IPrivateRouteProps>): JSX.Element {
  return (
    <Route exact={true} {...rest}>
      {condition ? children : fallback || <RedirectTo403 />}
    </Route>
  );
}

export default RouteWithPermissions;
